import React from "react";

export const LogoNew = (props) => (
    <img src={"/corsearch.png"} {...props} alt={"Corsearch"} title={"Powered by Corsearch"}/>
);
